export function stringToSlug (str) {
  str = str.toLowerCase()
  str = str.replace(/[éèêë]/g, 'e')
  str = str.replace(/[àä]/g, 'a')
  str = str.replace(/[ïî]/g, 'i')
  str = str.replace(/[ôö]/g, 'o')
  str = str.replace(/[ç]/g, 'c')
  str = str.replace(/[^a-z0-9]+/g, '-')
  str = str.replace(/^-+|-+$/g, '')
  return str
}
